import type { companies as en } from '@/i18n/locales/en/companies';
import type { Translation } from '@/i18n/types';

export const companies: Translation<typeof en> = {
  list: {
    title: 'Şirketler',
    newCompany: 'Yeni şirket',
    empty: 'Görebileceğiniz bir şirket yok.',
    name: 'Ad',
    created: 'Oluşturulma',
    rowsLabel: 'şirketler',
    healthTitle: 'Organizasyon sağlığı',
    healthCompanies: 'Şirketler',
    healthEditions: 'Sürümler',
    healthPilots: 'Pilotlar',
    healthPilotsLabel: 'pilot özeti',
    healthActivePilotCount: '{{count}} şirkette aktif pilot var',
  },
  detail: {
    thisCompany: 'şirket',
    rename: 'Yeniden adlandır',
    companyAdmins: 'Şirket yöneticileri',
    delete: 'Sil',
    departmentsTitle: 'Departmanlar',
    newDepartment: 'Yeni departman',
    departmentsEmpty: 'Henüz departman yok.',
    departmentsLabel: 'departmanlar',
    name: 'Ad',
    statistics: 'İstatistikler',
    collectiveConsent: 'Toplu rıza',
    inForce: 'yürürlükte',
    settingsTitle: 'Ayarlar',
    settingsLabel: 'ayarlar',
    change: 'Değiştir',
    minGroupSizeLabel: 'Toplu veriler için minimum grup boyutu:',
    systemDefault: 'sistem varsayılanı',
    companyOverride: 'şirkete özel değer',
    domainsTitle: 'E-posta alan adları',
    domainsLabel: 'alan adları',
    manage: 'Yönet',
    domainsEmpty: 'Kayıtlı alan adı yok.',
    membersTitle: 'Üyeler',
    membersLabel: 'üyeler',
    addPerson: 'Kişi ekle',
    membersEmpty: 'Üye yok.',
    email: 'E-posta',
    login: 'Giriş',
    source: 'Kaynak',
    actions: 'İşlemler',
    yes: 'evet',
    no: 'hayır',
  },
  form: {
    newTitle: 'Yeni şirket',
    name: 'Ad',
    cancel: 'İptal',
    create: 'Şirket oluştur',
    editTitle: 'Şirketi yeniden adlandır',
    save: 'Kaydet',
    deleteTitle: 'Şirketi sil',
    deleteLead:
      '{{name}} silindiğinde alan adları ve üyelik kayıtları da sona erer. Bu işlem geri alınamaz. Onaylamak için şirket adını yazın.',
    companyNameLabel: 'Şirket adı',
    deletePermanently: 'Kalıcı olarak sil',
    settingsTitle: 'Toplulaştırma eşiği',
    settingsLead:
      'Altında toplu verilerin gösterilmediği minimum grup boyutu. Sistem varsayılanına dönmek için boş bırakın. API mutlak bir alt sınır uygular.',
    minGroupSize: 'Minimum grup boyutu',
    domainsTitle: 'E-posta alan adları',
    domainsLead:
      'Bu alan adlarından birinde doğrulanmış bir adres, sahibini oturum açarken bu şirkete kaydeder. Bir alan adı kaldırıldığında mevcut üyelikler kalır.',
    remove: 'Kaldır',
    addDomain: 'Alan adı ekle',
    add: 'Ekle',
    backToCompany: 'Şirkete geri dön',
  },
  health: {
    title: 'Organizasyon sağlığı',
    edition: 'Sürüm',
    editionFit: 'Fit',
    editionSoccer: 'Soccer',
    members: 'Üyeler',
    pilotsTitle: 'Pilotlar',
    pilotsLabel: 'pilot durumu',
    noPilots: 'Henüz pilot yok.',
    activeCount: '{{count}} aktif',
    scaledCount: '{{count}} ölçeklendi',
    totalCount: 'toplam {{count}}',
    viewAllPilots: 'Tüm pilotları görüntüle',
  },
};
